import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList } from '@/api/system/device/device';
import { fetchCreate, fetchUpdate, fetchDetail } from '@/api/PMS/placeManage/placeManage';
export default {
  props: ['keyValue', 'showDialog', 'areaId'],
  data: function data() {
    return {
      rules: {
        placeName: [{
          required: true,
          message: '请输入场地名称',
          trigger: 'blur'
        }, {
          min: 1,
          max: 100,
          message: '长度在 1 到 100 个字符',
          trigger: 'change'
        }],
        status: [{
          required: true,
          message: '请选择场地状态',
          trigger: 'change'
        }]
      },
      childData: {
        placeName: '',
        areaId: ''
      },
      statusOptions: [{
        dicValue: 1,
        dicName: '正常'
      }, {
        dicValue: 2,
        dicName: '维护'
      }],
      deviceOption: [],
      deviceIds: []
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    statusChange: function statusChange() {
      delete this.childData.maintenanceDateStart;
      delete this.childData.maintenanceDateEnd;
    },
    getDeviceList: function getDeviceList() {
      var _this = this;

      fetchList({
        sysType: 'SCS'
      }).then(function (response) {
        _this.deviceOption = response.data.data;
      });
    },
    init: function init() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.$refs['dataForm'].clearValidate();
      });
      this.getDeviceList();
      this.deviceIds = [];

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          _this2.childData = response.data.data;

          if (_this2.childData.deviceId != null && _this2.childData.deviceId.length > 0) {
            _this2.childData.deviceId.split(',').forEach(function (element) {
              _this2.deviceIds.push(parseInt(element));
            });
          }
        });
      } else {
        this.childData = {
          placeName: '',
          maintenanceDateStart: '',
          maintenanceDateEnd: ''
        };
      }
    },
    handCreate: function handCreate() {
      var _this3 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          if (_this3.childData.status == 1) {
            if (_this3.childData.maintenanceDateStart != null && _this3.childData.maintenanceDateStart != '') {
              _this3.Alert({
                alertType: 'error',
                message: '场地状态为正常时不可选择维护时间'
              });

              return;
            }

            if (_this3.childData.maintenanceDateEnd != null && _this3.childData.maintenanceDateEnd != '') {
              _this3.Alert({
                alertType: 'error',
                message: '场地状态为正常时不可选择维护时间'
              });

              return;
            }
          }

          if (_this3.childData.status == 2) {
            if (_this3.childData.maintenanceDateStart == null || _this3.childData.maintenanceDateStart == '') {
              _this3.Alert({
                alertType: 'error',
                message: '请选择维护开始时间'
              });

              return;
            }

            if (_this3.childData.maintenanceDateEnd == null || _this3.childData.maintenanceDateEnd == '') {
              _this3.Alert({
                alertType: 'error',
                message: '请选择维护结束时间'
              });

              return;
            }
          }

          if (_this3.childData.maintenanceDateStart > _this3.childData.maintenanceDateEnd) {
            _this3.Alert({
              alertType: 'error',
              message: '维护开始时间不能大于维护结束时间'
            });

            return;
          }

          _this3.childData.deviceId = '';

          _this3.deviceIds.forEach(function (element) {
            _this3.childData.deviceId += element + ',';
          });

          _this3.childData.deviceId = _this3.childData.deviceId.substring(0, _this3.childData.deviceId.length - 1);

          if (_this3.keyValue > 0) {
            fetchUpdate(_this3.childData).then(function (res) {
              if (res.data.code == 200) {
                _this3.$emit('handCancle', true);

                _this3.Alert({
                  alertType: 'update'
                });
              }
            });
          } else {
            _this3.childData.areaId = _this3.areaId;
            fetchCreate(_this3.childData).then(function (res) {
              if (res.data.code == 200) {
                _this3.$emit('handCancle', true);

                _this3.Alert({
                  alertType: 'add'
                });
              }
            });
          }
        } else {
          _this3.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', false);
    }
  }
};